module.exports = __webpack_public_path__ + "static/media/event-room-icon--hover.6a41a2bc.svg";